export default "__VITE_ASSET__1_SxGFel__";